import React, { createContext, useState } from "react";
import SetupChargeService from "../services/SetupChargeService";

const initialState = {
  loading: false,
  SetupCharges: [],
};

const SetupChargesContext = createContext();

const SetupChargesContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getAllSetupCharges = async () => {
    setState({ ...state, loading: true });
    const data = await SetupChargeService.getAllSetupCharges();
    setState({ SetupCharges: data, loading: false });
  };

  const value = { state, setState, getAllSetupCharges };
  return (
    <SetupChargesContext.Provider value={value}>
      {children}
    </SetupChargesContext.Provider>
  );
};

const useSetupChargesContext = () => {
  const context = React.useContext(SetupChargesContext);
  if (context === undefined) {
    throw new Error(
      "SetupChargesContext must be used within a SetupChargesContextProvider"
    );
  }
  return context;
};

export { SetupChargesContextProvider, useSetupChargesContext };
